import { AllHTMLAttributes, ReactNode } from 'react'
import cn from 'classnames'

import './styles.scss'

export interface ButtonProps extends AllHTMLAttributes<HTMLButtonElement> {
  before?: ReactNode
  after?: ReactNode
  width?: string | number
  uppercase?: boolean
  disabled?: boolean
}

export const Button = (props: ButtonProps) => {
  const { before, after, uppercase, width, children, className, ...rest } = props

  return (
    <button
      className={cn('button', { uppercase }, className)}
      style={{ width }}
      {...rest}
      type="button"
    >
      {before && <div className="before">{before}</div>}
      <div className="content">{children}</div>
      {after && <div className="after">{after}</div>}
    </button>
  )
}
